import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DialogConfig } from 'src/modules/base/components/dialog/dialog-config';
import { AuthenticationService } from 'src/modules/base/shared/services/authentication.service';
import { AlertsService } from 'src/modules/base/services/alerts.service';

interface Conference {
  id: string;
  topic: string;
  url: string;
  created_at?: string;
}

@Component({
    selector: 'app-conference-dashboard',
    templateUrl: './conference-dashboard.component.html',
    styleUrls: ['./conference-dashboard.component.scss'],
    standalone: false
})
export class ConferenceDashboardComponent implements OnInit {
  currentConference: Conference | null = null;
  allConferences: Conference[] = [];
  newTopic: string = '';  recordingStarted: boolean = false;
  patientId: string = ''; // You can set this dynamically
  joinEmbedUrl: string = '';
  activeTab: 'current' | 'all' = 'current';
  loadingDetails: boolean = false;

  private apiUrl = "aiml-services/api/trueconf";

  constructor(private http: HttpClient,public dialogConfig:DialogConfig, private authService: AuthenticationService,
    private alerts:AlertsService
  ) { }

  ngOnInit(): void {
    this.patientId = this.dialogConfig.data.menuData.uhId;
    // this.newTopic = this.dialogConfig.data.menuData.serviceRequestId;
    // this.createConference();
    this.fetchCurrentConference();
    this.fetchAllConferences();
  }

  fetchCurrentConference() {
    this.http.get<Conference[]>(`${this.apiUrl}/conference/patient/${this.patientId}/current`)
      .subscribe(list => {
        this.currentConference = list.length ? list[0] : null;
        this.joinEmbedUrl = this.currentConference?.url || '';
      }, err => {
        console.error('Error fetching current conference', err);
      });
  }

  endConference() {
    if (!this.currentConference) return;
    if (!confirm('End this conference?')) return;
  
    this.http.delete(`${this.apiUrl}/conference/${this.currentConference.id}`)
      .subscribe(() => {
        this.currentConference = null;
        this.joinEmbedUrl = '';
        this.fetchAllConferences();
      }, err => console.error('Error ending conference', err));
  }

  fetchAllConferences() {
    this.http.get<Conference[]>(`${this.apiUrl}/conference/patient/${this.patientId}`)
      .subscribe(list => this.allConferences = list, err => {
        console.error('Error fetching all conferences', err);
      });
  }

  createConference() {
    if (!this.newTopic.trim()) {
      alert('Please enter a topic');
      return;
    }

    this.http.post<Conference>(`${this.apiUrl}/conference`, {
      patient_id: this.patientId,
      topic: this.newTopic
    }).subscribe(conf => {
      this.currentConference = conf;
      this.joinEmbedUrl = conf.url;
      this.allConferences.unshift(conf);
      this.newTopic = '';
      // this.activeTab = 'current';
    }, err => {
      console.error('Error creating conference', err);
      alert('Could not create conference');
    });
  }

  startRecording(){
    let topic = `${this.currentConference.id}`
    this.http.post<Conference>(`${this.apiUrl}/start-record`, {
      patient_id: this.patientId,
      topic: topic
    }).subscribe((conf:any) => {
      if(conf.status == "202"){
      this.alerts.info("Recording started");
      this.recordingStarted = true;
      }else{
        this.alerts.error("Recording could not be started");
        this.recordingStarted = false;
      }
    }, err => {
      console.error('Error creating conference', err);
      alert('Could not create conference');
    });
  }

  checkPatient(){
    return this.authService.getUserType() === 'patient';
  }

  stopRecording(){
    let topic = `${this.currentConference.id}`
    this.http.post<Conference>(`${this.apiUrl}/stop-record`, {
      patient_id: this.patientId,
      topic: topic
    }).subscribe((conf:any) => {
      if(conf.status == "202"){
      this.alerts.info("Recording stoped");
      this.recordingStarted = false;
      }else{
        this.alerts.error("Error stopping recording");
        this.recordingStarted = false;
      }
      
    }, err => {
      console.error('Error creating conference', err);
      alert('Could not create conference');
    });
  }

  selectConference(conf: Conference) {
    this.currentConference = conf;
    this.joinEmbedUrl = conf.url;
    // this.activeTab = 'current';
  }

  switchTab(tab: 'current' | 'all') {
    this.activeTab = tab;
  }
}
